import axios from '../Axios/Default';
import { handleResponse } from '../Utils/Utils';

export const getERatingAll = (_params, onSuccess, onError) => {
    const response = axios.get('v1/admin/e-rating', { params: _params });
    return handleResponse(response, onSuccess, onError);
};

export const getERatingById = (id, onSuccess, onError) => {
    const response = axios.get(`v1/admin/e-rating/${id}`);
    return handleResponse(response, onSuccess, onError);
};

export const createERating = (payload, onSuccess, onError) => {
    const response = axios.post(`v1/admin/e-rating`, payload);
    return handleResponse(response, onSuccess, onError);
};

export const updateERating = (id, payload, onSuccess, onError) => {
    const response = axios.put(`v1/admin/e-rating/${id}`, payload);
    return handleResponse(response, onSuccess, onError);
};

export const softDeleteERating = (id, payload, onSuccess, onError) => {
    const response = axios.put(`v1/admin/e-rating/${id}/delete`, payload);
    return handleResponse(response, onSuccess, onError);
};

export const deleteERating = (id, onSuccess, onError) => {
    const response = axios.delete(`v1/admin/e-rating/${id}`);
    return handleResponse(response, onSuccess, onError);
};